module.exports = __webpack_public_path__ + "src/assets/img/input/55bf58e499e4b8779e8d254478a27b92.png";